export default "/images/c730ff8f92c9ad5f5037de87c381fe4c.avif";